(function passwordStrengthDirectiveDefinition() {

    'use strict';

    function DefaultStrengthAlgorithm() {
        // Si se desea se puede colocar un elemento itemClasses con las clases o colores 
        // de los items en base a getStrengthClassIndex. (si comienza con # )
        this.measureStrength = function (p) {
            var score = 0;
            var password = String(p);
            var passwordLength = password.length;
            if (passwordLength < 1) {
                return 0;
            }

            if (passwordLength < 3) {
                return 0;
            }

            if (passwordLength < 6) {
                return 1;
            }

            if (passwordLength >= 6) {
                score++;
            }

            if (passwordLength > 8) {
                score++;
            }

            if (/[0-9]+/.test(p)) {
                score++;
            }

            if (/[a-z]+/.test(p) ||
                /[A-Z]+/.test(p)) {
                score++;
            }

            var symbols = /[!,@,#,$,%,^,&,*,?,_,~,-,�,(,)]/g;
            if (symbols.test(p)) {
                score++;
            }

            return score;
        };

        this.getStrengthClassIndex = function (s) {
            return s + 1;
        };
    };

    var directiveFactory = ['$compile', 'checkStrengthConfig', '$injector',
            function ($compile, checkStrengthConfig, $injector) {
                return {
                    scope: true,
                    require: '^^form',
                    restrict: 'A',
                    link: function (scope, element, attrs, formCtrl) {

                        var algorithm = null,
                            algorithmName = 'default',
                            validateStrength = false;

                        // si se especifica un checkStrengthAlgorithm lo uso.
                        if (attrs.checkStrengthAlgorithm) {
                            algorithmName = attrs.checkStrengthAlgorithm;
                        }

                        if (attrs.checkStrengthValidation === 'true' || attrs.checkStrengthValidation === '') {
                            validateStrength = true;
                        }
                        
                        algorithm = checkStrengthConfig.algorithms[algorithmName];
                        
                        var barClasses = (algorithm.itemClasses || checkStrengthConfig.itemClasses);
                        var requiredStrength = algorithm.requiredStrength || checkStrengthConfig.requiredStrength || -1;

                        scope.$strength = -1;

                        var barWidth = Math.ceil(10000 / barClasses.length) / 100;

                        // armo los elementos de la barra
                        scope.$strengthBars = barClasses.map(function (itemClass) {

                            var style = { width: barWidth + '%' },
                                textStyle = null,
                                finalItemClass = null;

                            if (typeof (itemClass) === 'string'
                                && itemClass.charAt(0) === '#') {
                                // es un color
                                style['background-color'] = itemClass ;
                            } else {
                                finalItemClass = itemClass;
                            }
                            
                            return {
                                itemClass: finalItemClass,
                                style: style
                            }
                        });

                        scope.$strengthBars[scope.$strengthBars.length - 1].value = (100 - barWidth * (scope.$strengthBars.length - 1));
                        
                        var barsElement = angular.element('<li ng-repeat="bar in $strengthBars track by $index" class="strength-bar" ng-class="bar.itemClass" ng-style="bar.style" ng-hide="$strength < $index"></li>');
                        
                        var inputControl = null,
                            labelControl = null,
                            showMode = '';  // label, below-input, above-input

                        if (element[0].tagName === 'LABEL') {

                            labelControl = element;

                            if (/col\-..-\d{1,2}/gi.test(labelControl[0].className)) {
                                if ((attrs.checkStrengthAboveInput && attrs.checkStrengthAboveInput !== 'false')
                                    || (attrs.checkStrengthBelowInput && attrs.checkStrengthBelowInput === 'false')) {
                                    showMode = 'above-input';
                                } else {
                                    showMode = 'below-input';
                                }
                            } else {
                                showMode = 'label';
                            }

                            // está en el label -> usando el for busco el input.
                            if (element.attr('for')) {
                                inputControl = element.closest('.form-group')
                                                      .find('#' + element.attr('for'))
                                                      .first();
                            } else {
                                inputControl = element.closest('.form-group')
                                                      .find('input[type=password]')
                                                      .first();
                            }

                        } else if (element[0].tagName === 'INPUT') {
                            inputControl = element;

                            if ((attrs.checkStrengthAboveInput && attrs.checkStrengthAboveInput !== 'false')
                                   || (attrs.checkStrengthBelowInput && attrs.checkStrengthBelowInput === 'false')) {
                                showMode = 'above-input';
                            } else {
                                showMode = 'below-input';
                            }

                        } else {
                            // está en el group o algo que tiene como hijos los otros controles.

                            inputControl = element.find('input[type=\'password\']')
                                                  .first();

                            if (inputControl.length) {
                                labelControl = element.find('label[for=\'' + inputControl.attr('id') + '\']')
                                                      .first();

                                if (!labelControl.length
                                    || (labelControl.length && (/col\-..-\d{1,2}/gi.test(labelControl[0].className)))) {

                                    if ((attrs.checkStrengthAboveInput && attrs.checkStrengthAboveInput !== 'false')
                                        || (attrs.checkStrengthBelowInput && attrs.checkStrengthBelowInput === 'false')) {
                                        showMode = 'above-input';
                                    } else {
                                        showMode = 'below-input';
                                    }

                                } else  {

                                    if ((attrs.checkStrengthAboveInput && attrs.checkStrengthAboveInput !== 'false')
                                        || (attrs.checkStrengthBelowInput && attrs.checkStrengthAboveInput === 'false')) {
                                        showMode = 'above-input';
                                    } else if ((attrs.checkStrengthAboveInput && attrs.checkStrengthAboveInput === 'false')
                                        || (attrs.checkStrengthBelowInput && attrs.checkStrengthBelowInput !== 'false')) {
                                        showMode = 'below-input';
                                    } else {
                                        showMode = 'label';
                                    }

                                }
                            } else {
                                console.error('No se encontró el input del control.');
                                return;
                            }
                        }

                        /*
                         *  Ahora ubico el control según el modo de visualización
                         */
                        var container = angular.element('<ul class="password-strength"></ul>');
                        container.append(barsElement);

                        if (showMode !== 'label') {
                            if (showMode !== 'above-input') {
                                // lo muestro abajo o arriba del input
                                container.insertBefore(inputControl);
                                container.addClass('password-strength-above-input');
                            } else {
                                // lo muestro abajo o arriba del input
                                container.insertAfter(inputControl);
                                container.addClass('password-strength-below-input');
                            }
                        } else {
                            // si el label tiene una clase col-xx-* entonces lo pongo arriba del input y con la clase que le saca el margen derecho.
                            container.addClass('password-strength-after-label');

                            // lo muestro al lado del label
                            container.insertAfter(labelControl);
                        }
                        
                        if (attrs.checkStrengthWithLabel === '') {

                            // Mensaje (si se especifican)
                            if (attrs.checkStrengthMessages && attrs.checkStrengthMessages !== 'false') {
                                scope.$watch(attrs.checkStrengthMessages, function (value) {
                                    scope.$strengthMessages = value;
                                });
                            } else {
                                scope.$strengthMessages = algorithm.messages || checkStrengthConfig.messages;
                            }

                            var translate = '';
                            if ($injector.has('$translate')) {
                                translate = ' | translate';
                            }

                            var label = angular.element('<span class="password-strength-label' + (showMode !== 'below-input'? '':'-right') +'" class=""><small>{{$strengthMessages[$strength]' + translate + '}}</small></span>')
                                               .insertAfter(container);
                            $compile(label)(scope);
                        }

                        // compilo el elemento insertado al DOM.
                        $compile(container)(scope);

                        scope.$watch(inputControl.attr('ng-model'), function (value) {

                            if (!value) {
                                scope.$strength = -1;
                            } else {

                                scope.$strength =  algorithm.measureStrength(value);
                            }

                            if (validateStrength) {

                                if (inputControl && inputControl.length) {
                                    // seteo el validity
                                    var modelCtrl = formCtrl[inputControl[0].name];

                                    if (modelCtrl) {
                                        // seteo el validity
                                        modelCtrl.$setValidity('strength', scope.$strength >= requiredStrength);
                                    }
                                }
                            }
                        });

                    }
                };
            }];

    angular.module('PasswordStrength', [])
        .value('checkStrengthConfig', {
            itemClasses: ['#d43f3a',
                          '#ff8533',
                          '#ffb033',
                          '#ffda48',
                          '#5cb85c',
                          '#5ad770'],
            getStrengthClassIndex: function (s) {
                return s + 1;
            },
            algorithms: { 'default': new DefaultStrengthAlgorithm() },
            requiredStrength: 3,
            messages: ['PasswordStrengthBad',
                       'PasswordStrengthLow',
                       'PasswordStrengthMedium',
                       'PasswordStrengthHigh',
                       'PasswordStrengthStrong',
                       'PasswordStrengthStrongest']
        })
        .directive('checkStrength', directiveFactory)
        .directive('checkStrengthBelowInput', directiveFactory)
        .directive('checkStrengthWithLabel', directiveFactory)
        .directive('checkStrengthAboveInput', directiveFactory);
})();